/**
 * @module
 * @name Paginator
 * @description Two-way biding paginator.
 */
export default {
  name: 'Paginator',

  /**
   * @property {Number} first First number of the paginator, if exists.
   * @property {Number} current Current page.
   * @property {Number} total Total pages.
   */
  props: {
    first: {
      type: Number,
      required: false,
      default: 1
    },
    current: {
      type: Number
    },
    total: {
      type: Number
    },
    handleClickDecreasePage: {
      type: Function,
      required: false
    },
    handleClickIncreasePage: {
      type: Function,
      required: false
    }
  },

  /**
   * @property {String} inputWidth Used in CSS style.
   */
  computed: {
    inputWidth: function () {
      const totalLength = this.total ? this.total.toString().length : 1
      return `${totalLength}.5rem`
    }
  },

  methods: {
    /**
     * @function
     * @name setPage
     * @description Checks if the targetPage is valid and then emit and event to
     *              change it. props.current will be updated.
     * @param {Number} targetPage Target page.
     * @fires page:update
     */
    setPage: function (targetPage) {
      if (this.validPage(targetPage)) {
        this.$emit('page:update', this.parsePage(targetPage))
      } else {
        this.$el.querySelector('input').value = this.current
      }
    },

    /**
     * @function
     * @name parsePage
     * @description Checks if it's a number and then parse it. If not, return null.
     * @param {Number} page
     */
    parsePage: function (page) {
      return isNaN(page) ? null : parseInt(page)
    },

    /**
     * @function
     * @name validPage
     * @description Validates page number. Checks if the page is in range.
     * @param {Number} page Target page number.
     */
    validPage: function (page) {
      return page && (page >= this.first && page <= this.total) // notnumbers
    }
  }
}
